import type { UserNotificationSettingsDto } from '~/src/shared/types/generated'

export const defaultNotificationSettings: UserNotificationSettingsDto = {
    siteNotification: {
        techWorks: false,
        promotion: false,
        newBlogArticle: false,
        subscriptionEndWarning: false,
        subscriptionEndWarningDays: 3,
    },
    emailNotification: {
        promotion: false,
        newBlogArticle: false,
        subscriptionEndWarning: false,
        subscriptionEndWarningDays: 3,
    },
}
